import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { NetworkStatusProvider } from './contexts/NetworkStatusContext';

// Hide the static title div as soon as React loads
const staticTitle = document.getElementById('static-app-title');
if (staticTitle) staticTitle.style.display = 'none';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <NetworkStatusProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </NetworkStatusProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(); 